<template>
    <div>
        <Head title="Create Project"/>
        <h1 class="mb-8 text-3xl font-bold">
            <Link class="text-indigo-400 hover:text-indigo-600" href="/projects">Projects</Link>
            <span class="text-indigo-400 font-medium">/</span> Create
        </h1>
        <div class="max-w-3xl bg-white rounded-md shadow overflow-hidden">
            <form @submit.prevent="store">
                <div class="flex flex-wrap -mb-8 -mr-6 p-8">
                    <text-input v-model="form.name" :error="form.errors.name" class="pb-8 pr-6 w-full lg:w-1/2"
                                label="Name"/>
                    <text-input v-model="form.type" :error="form.errors.type" class="pb-8 pr-6 w-full lg:w-1/2"
                                label="Type"/>
                    <text-input v-model="form.address" :error="form.errors.address" class="pb-8 pr-6 w-full lg:w-1/2"
                                label="Address"/>
                    <text-input v-model="form.bedroom" :error="form.errors.bedroom" class="pb-8 pr-6 w-full lg:w-1/2"
                                label="No of BedRooms"/>
                    <text-input v-model="form.bathroom" :error="form.errors.bathroom" class="pb-8 pr-6 w-full lg:w-1/2"
                                label="No of BathRooms"/>
                    <text-input v-model="form.store" :error="form.errors.store" class="pb-8 pr-6 w-full lg:w-1/2"
                                label="No of Stores"/>
                    <text-input v-model="form.kitchen" :error="form.errors.kitchen" class="pb-8 pr-6 w-full lg:w-1/2"
                                label="No of kitchen Rooms"/>
                    <text-input v-model="form.size_per_sq_meter" :error="form.errors.size_per_sq_meter"
                                class="pb-8 pr-6 w-full lg:w-1/2"
                                label="Size Per Square Meter"/>
                    <text-input v-model="form.estimated_budget" :error="form.errors.estimated_budget"
                                class="pb-8 pr-6 w-full lg:w-1/2"
                                label="Estimated Budget"/>
                    <text-input v-model="form.actual_budget" :error="form.errors.actual_budget"
                                class="pb-8 pr-6 w-full lg:w-1/2"
                                label="Actual Budget"/>
                    <text-input v-model="form.price" :error="form.errors.price"
                                class="pb-8 pr-6 w-full lg:w-1/2"
                                label="Project Price"/>
                    <text-input v-model="form.latitude" :error="form.errors.latitude" class="pb-8 pr-6 w-full lg:w-1/2"
                                label="Latitude"/>
                    <text-input v-model="form.longitude" :error="form.errors.longitude"
                                class="pb-8 pr-6 w-full lg:w-1/2"
                                label="Longitude"/>


                    <text-input v-model="form.start_date" :error="form.errors.start_date" type="date"
                                class="pb-8 pr-6 w-full lg:w-1/2" label="Start Date"/>

                    <select-input v-model="form.status" v-bind:value="form.status" :error="form.errors.status"
                                  class="pb-8 pr-6 w-full lg:w-1/2" label="Project Status">
                        <option value="pending">Pending</option>
                        <option value="active">Active</option>
                        <option value="ongoing">Ongoing</option>
                        <option value="completed">Completed</option>
                        <option value="cancelled">Cancelled</option>

                    </select-input>


                    <text-input v-model="form.youtube_url" :error="form.errors.youtube_url"
                                class="pb-8 pr-6 w-full lg:w-1/2"
                                label="Youtube URL"/>


                    <textarea-input v-model="form.description" :error="form.errors.description"
                                    class="pb-8 pr-6 w-full lg:w-1/2"
                                    label="Description"/>
                </div>
                <div class="flex items-center justify-end px-8 py-4 bg-gray-50 border-t border-gray-100">
                    <loading-button :loading="form.processing" class="btn-indigo" type="submit">Create Project
                    </loading-button>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
import {Head, Link} from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'
import FileInput from '@/Shared/FileInput'
import TextInput from '@/Shared/TextInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'
import TextareaInput from "@/Shared/TextareaInput"


export default {
    components: {
        TextareaInput,
        FileInput,
        Head,
        Link,
        LoadingButton,
        SelectInput,
        TextInput,
    },
    layout: Layout,
    remember: 'form',
    data() {
        return {
            form: this.$inertia.form({
                name: '',
                type: '',
                address: '',
                description: '',
                bedroom: '',
                bathroom: '',
                youtube_url: '',
                status: '',
                start_date: '',
                latitude: '',
                longitude: '',
                actual_budget: '',
                estimated_budget: '',
                size_per_sq_meter: '',
                price: '',
                kitchen: '',
            }),
        }
    },
    methods: {
        store() {
            this.form.post('/projects')
        },
    },
}
</script>
